import { useAppDispatch, useAppSelector } from "@/app/hooks";
import StatisticsCard from "@/components/dashboard/StatisticsCard";
import { useCurrentUser } from "@/context/UserContext";
import { selectUserLeaveCounts } from "@/features/leaveRequests/leaveRequestSelector";
import { fetchLeaveRequestsOfUser, fetchUserLeaveRequestsCount } from "@/features/leaveRequests/leaveRequestSlice";
import { ApprovalType, LeaveRequestDTO } from "@/models/leave-requests.model";
import React, { useEffect } from "react";
import { CgUnavailable } from "react-icons/cg";
import { IoMdDoneAll } from "react-icons/io";
import { MdOutlinePendingActions } from "react-icons/md";

function Statistics() {
  const { currentUser } = useCurrentUser()
  const dispatch = useAppDispatch();
  const userCounts = useAppSelector(selectUserLeaveCounts);
  console.log("userCounts", userCounts);

  useEffect(() => {
    if (!currentUser?.id) return;
    dispatch(fetchUserLeaveRequestsCount(currentUser.id))
  }, [dispatch]);

  return (
    <div className="flex w-full sm:h-[100px] h-[130px] justify-between items-center sm:gap-5 gap-2 ">
      <StatisticsCard
        statValue={
          userCounts?.[ApprovalType.PENDING] || 0
        }
        statTitle="Pending Approval"
        statIcon={<MdOutlinePendingActions color="
#fb923c" className="min-w-5 min-h-5" />}
        statIconBgColor="bg-orange-100"
      />
      <StatisticsCard
        statValue={
          userCounts?.[ApprovalType.APPROVED] || 0
        }
        statTitle="Requests Approved"
        statIcon={<IoMdDoneAll color="
#34d399" className="min-w-5 min-h-5" />}
        statIconBgColor="bg-green-100"
      />
      <StatisticsCard
        statValue={
          userCounts?.[ApprovalType.REJECTED] || 0
        }
        statTitle="Requests Rejected"
        statIcon={<CgUnavailable color="
#f87171" className="min-w-5 min-h-5" />}
        statIconBgColor="bg-red-100"
      />
      {/* icon in -400 */}
    </div>
  );
}

export default Statistics;